<template>
  <div class="container-fluid">
    <b-row>
      <b-col lg="12" class="p-0" :class="(isIE) ? 'isIE' : ''">
        <div id="nav" :class="[(scrolled) ? 'scrolled' : 'not-scrolled', (isOpen) ? 'menu-active' : '']" :style="(scrolled && !isOpen) ? 'height:' +nav_height['scrolled']+ 'px' : 'height:' +nav_height['default']+ 'px'">
          <header class="position-relative mx-auto container">
            <b-row class="h-100">
              <b-col cols="6" md="4" class="h-100">
                <div class="logo h-100 w-100" :class="(!isIE) ? 'd-table' : ''">
                  <div class="d-table-cell text-left align-middle w-100" :class="(!isIE) ? 'd-table-cell' : ''">
                    <router-link tag="div" class="cursor-pointer logo-link" v-on:click.native="close_nav" :to="'/' +app_lang+ '/'">
                      <transition-group :duration="{ enter: 300, leave: 300 }"
                      name="fade" 
                      mode="out-in">
                        <img v-show="scrolled && !isOpen" key="blue" alt="Logo" src="../assets/images/Logo_SonagiBlue-02.svg" class="position-absolute">
                        <img v-show="!scrolled || isOpen" key="white" alt="Logo" src="../assets/images/Logo_SonagiWhite-01.svg" class="position-absolute">
                      </transition-group>
                        <!-- <img v-show="scrolled && !isOpen" alt="Logo" src="../assets/images/Logo_SonagiBlue-02.svg">
                        <img v-show="!scrolled || isOpen" alt="Logo" src="../assets/images/Logo_SonagiWhite-01.svg"> -->
                    </router-link>
                  </div>
                </div> 
              </b-col>
              <b-col md="7" cols="5" class="pr-0 h-100">
                <div class="lang-wrapper desk h-100 w-100" :class="[(!isOpen) ? 'd-md-block d-none' : 'd-table', (!isIE) ? 'd-md-table' : '']">
                  <div class="text-right align-middle w-100" :class="(!isIE) ? 'd-table-cell' : ''">
                    <router-link :class="($route.params.lang === 'pt') ? 'lang-desk-active' : ''" class="f-gotham lang-desk" v-on:click.native="close_nav" :to="{name: $route.name, params: {lang: 'pt', type: $route.params.type}}">PT</router-link>
                    <router-link :class="($route.params.lang === 'en') ? 'lang-desk-active' : ''" class="f-gotham lang-desk" v-on:click.native="close_nav" :to="{name: $route.name, params: {lang: 'en', type: $route.params.type}}">EN</router-link>
                  </div>
                </div>
              </b-col>
              <b-col cols="1" md="1" class="pl-0 h-100">
                <div class="btn-wrapper h-100" :class="(!isIE) ? 'd-table' : ''">
                  <label class="toggle-btn align-middle" :class="[(isOpen) ? 'open-btn-active' : '', (!isIE) ? 'd-table-cell' : '']" v-on:click="isOpen = !isOpen">
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="position-relative"><span class="position-absolute hamburger-menu-word f-gotham">MENU</span></div>
                  </label>
                </div>
              </b-col>
            </b-row>
            <nav :class="(isOpen) ? 'open-active' : ''" class="h-100 p-0 m-0">
              <div class="menu-wrapper container">
                <b-row class="min-vh-100 no-min-h">
                  <b-col cols="12" class="position-relative">
                    <!-- <b-row class="menu-top">
                      <b-col cols="6">
                        <div class="nav-logo">
                          <router-link tag="div" class="cursor-pointer" v-on:click.native="close_nav" :to="'/' +app_lang+ '/'">
                            <img alt="Logo" src="../assets/images/Logo_SonagiWhite-01.svg">
                          </router-link>
                        </div>
                      </b-col>
                      <b-col cols="6">
                        <div class="nav-langs text-right">
                          <div class="lang-wrapper mob link-ani-6 p-0 position-relative">
                              <router-link exact-active-class="lang-mob-active" class="f-gotham lang-mob" v-on:click.native="close_nav" :to="{name: $route.name, params: {lang: 'pt', type: $route.params.type}}">PT</router-link>
                              <router-link exact-active-class="lang-mob-active" class="f-gotham lang-mob" v-on:click.native="close_nav" :to="{name: $route.name, params: {lang: 'en', type: $route.params.type}}">EN</router-link>
                          </div>
                        </div>
                      </b-col>
                    </b-row> -->
                  </b-col>
                  <b-col cols="12">
                    <b-row class="menu-content">
                      <b-col md="6" class="d-table min-vh-100">
                        <div class="links-wrapper d-table-cell align-middle">
                          <ul class="text-md-left text-center p-0 m-0 links">
                            <li class="link-ani-1">
                              <div class="link-mask">
                                <div>
                                  <router-link class="d-inline-block section-title" v-on:click.native="close_nav" :to="'/' +app_lang+ '/'" :class="($route.name == 'home') ? 'line-up-white' : 'border-ani-center-white'">{{configs['menu_home']}}</router-link>
                                </div>
                              </div>
                            </li>
                            <li class="link-ani-2">
                              <div class="link-mask">
                                <div>
                                  <router-link class="d-inline-block section-title" v-on:click.native="close_nav" :to="'/' +app_lang+ '/about'" :class="($route.name == 'about') ? 'line-up-white' : 'border-ani-center-white'">{{configs['menu_about_us']}}</router-link>
                                </div>
                              </div>
                            </li>
                            <li class="link-ani-3">
                              <div class="link-mask">
                                <div>
                                  <router-link class="d-inline-block section-title" v-on:click.native="close_nav" :to="'/' +app_lang+ '/portfolio/real-estate-investement'" :class="($route.name == 'portfolio') ? 'line-up-white' : 'border-ani-center-white'">{{configs['menu_portfolio']}}</router-link>
                                </div>
                              </div>
                            </li>
                            <li class="link-ani-4">
                              <div class="link-mask">
                                <div>
                                  <router-link class="d-inline-block section-title" v-on:click.native="close_nav" :to="'/' +app_lang+ '/investors'" :class="($route.name == 'investors') ? 'line-up-white' : 'border-ani-center-white'">{{configs['menu_investors']}}</router-link>
                                </div>
                              </div>
                            </li>
                            <li class="link-ani-5">
                              <div class="link-mask">
                                <div>
                                  <router-link class="d-inline-block section-title" v-on:click.native="close_nav" :to="'/' +app_lang+ '/contacts'" :class="($route.name == 'contacts') ? 'line-up-white' : 'border-ani-center-white'">{{configs['menu_contacts']}}</router-link>
                                </div>
                              </div>
                            </li>
                           <!--  <ul class="lang-wrapper mob link-ani-6 p-0">
                                  <router-link exact-active-class="lang-mob-active" class="f-gotham lang-mob" v-on:click.native="close_nav" :to="{name: $route.name, params: {lang: 'pt', type: $route.params.type}}">PT</router-link>
                                  <router-link exact-active-class="lang-mob-active" class="f-gotham lang-mob" v-on:click.native="close_nav" :to="{name: $route.name, params: {lang: 'en', type: $route.params.type}}">EN</router-link>
                            </ul> -->
                          </ul>
                          <div class="d-block d-md-none">
                            <p class="text-md-right text-white text-center nav-address mob">
                              Av. Fontes Pereira de Melo, 14 - 7º,
                              <br>
                              1050-121 Lisboa - Portugal
                              <br><br>
                              <a href="callto:+351213184800">
                              +351 21 318 48 00
                              </a>
                              <br>
                              +351 21 357 22 60
                              <br>
                              <a class="email" href="mailto:sonagi@sonagi.pt">sonagi@sonagi.pt</a>
                            </p>
                          </div>
                        </div>
                      </b-col>
                      <b-col md="6" class="d-md-table d-none min-vh-100">
                        <div class="d-table-cell align-middle">
                          <p class="text-md-right text-white text-center nav-address">
                            Av. Fontes Pereira de Melo, 14 - 7º,
                            <br>
                            1050-121 Lisboa - Portugal
                            <br><br>
                            <a href="callto:+351213184800">
                            +351 21 318 48 00
                            </a>
                            <br>
                            +351 21 357 22 60
                            <br>
                            <a class="email" href="mailto:sonagi@sonagi.pt">sonagi@sonagi.pt</a>
                          </p>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </nav>
          </header>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'Nav',
  props: {
    app_lang: String,
    nav_height: Object
  },
  data() {
    return {
      isOpen: false,
      scrolled: false,
    }
  },
  watch: {
    '$route.name': function(new_val, old_val) {
      if(!this.$route.meta.has_nav_effect) {
        this.scrolled = true;
        window.removeEventListener('scroll', this.handleScroll);
      }
      else {
        this.scrolled = this.has_scrolled();
        window.addEventListener('scroll', this.handleScroll);
      }
    }
  },
  methods: {
    handleScroll () {
      this.scrolled = this.has_scrolled();
    },
    has_scrolled: function() {
      if(this.isIE) {
        return window.pageYOffset >= document.documentElement.clientHeight - 380 && this.$route.meta.has_nav_effect;
      }
      return window.scrollY >= window.innerHeight - 380 && this.$route.meta.has_nav_effect;
    },
    close_nav: function() {
      this.isOpen = false;
      if(this.$route.name === 'home') {
        window.scrollTo(0, 0);
      }
    }
  },
  created () {
    if(this.$route.meta.has_nav_effect) {
      window.addEventListener('scroll', this.handleScroll);
    }
    this.scrolled = this.has_scrolled();
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
<style scoped>

#nav {
  background-color: transparent;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  -moz-transition: all .2s ease-in-out;
  -webkit-transition: all .2s ease-in-out;
  -o-transition: all .2s ease-in-out;
  transition: all .2s ease-in-out;
}
.isIE #nav {
  /*transition: height .2s ease-in-out;*/
}
#nav header {
  height: 100%;
}
#nav.scrolled, #nav.menu-active {
  background-color: #ffffff;
  -webkit-box-shadow: -1px 4px 33px -5px rgba(120,120,120,1);
  -moz-box-shadow: -1px 4px 33px -5px rgba(120,120,120,1);
  box-shadow: -1px 4px 33px -5px rgba(120,120,120,1);
}
#nav.menu-active.not-scrolled {
  background-color: transparent;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}
#nav .lang-wrapper, #nav .logo {
  position: absolute;
  top: 0;
  z-index: 10;
}
.isIE #nav .lang-wrapper, #nav .logo {
  top: auto;
  position: relative;
}

.isIE #nav .logo .isIE #nav .lang-wrapper .isIE #nav .btn-wrapper {
  transition: all .2s ease-in-out;
}
.isIE #nav .logo{
  margin-top: 12px;
}
.isIE #nav .lang-wrapper{
  margin-top: 18px;
}
.isIE #nav .btn-wrapper{
  margin-top: 13px;
}

.isIE #nav.not-scrolled .logo, .isIE #nav.menu-active.scrolled .logo  {
  margin-top: 52px;
}
.isIE #nav.not-scrolled .lang-wrapper, .isIE #nav.menu-active.scrolled .lang-wrapper  {
  margin-top: 60px;
}
.isIE #nav.not-scrolled .btn-wrapper, .isIE #nav.menu-active.scrolled .btn-wrapper  {
  margin-top: 55px;
}
#nav .logo {
  /*left: 15px;*/
}
#nav .lang-wrapper {
  right: -15px;
}
#nav .logo-link {
  height: 38px;
}
.isIE #nav .logo-link img {
  
}
#nav .lang-wrapper a {
  font-size: 10px;
  display: inline-block;
  width: 30px;
  line-height: 1;
  transition: all .2s ease-in-out;
  text-align: center;
  background-color: #ffffff;
  border: 2px solid #ffffff;
  color: #00263d;
  padding:  5px 0 3px 0;
}
.isIE #nav .lang-wrapper a {
  transition: all 0 ease-in-out;
}
#nav .lang-wrapper a {
    
}
#nav.scrolled .lang-wrapper a {
  border: 2px solid #00263d;
}
#nav.menu-active .lang-wrapper a {
  border: 2px solid #ffffff;
}
#nav .lang-wrapper a.lang-desk-active {
  background-color: #00263d;
  color: #ffffff;
}

#nav .lang-wrapper a:hover {
  text-decoration: none;
}

#nav .nav-address {
  height: 350px;
  font-size: 0.9rem;
  padding-top: 205px;
}
#nav .nav-address a {
  text-decoration: none;
  color: inherit;
}
#nav .nav-address a:hover {
  text-decoration: underline;
}

/* MENU ANIMATION */

.fade-enter-active, .fade-leave-active { /* logo change */
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

nav {
  background-color: rgba(0, 38, 61, 1);
  position: fixed;
  z-index: 1;
  top: 0;
  left: -100%;
  width: 100% !important;
  /*width: 0;*/
  /*transition: width 0.8s cubic-bezier(.95,-0.26,.21,1.01);*/
  transition: all 0.8s ease-in-out 0s;
}

nav ul.links {
  list-style-type: none;
  transition: all 0.3s ease-in-out;
}
/*nav ul.links li.menu-top {
  top: -20px;
  z-index: 99;
}
nav ul.links li:not(.menu-top) {
  position: relative;
  top: -60px;
}
nav ul.links li.menu-top.langs-links {
  right: -92.5%;
  display: none;
}
nav ul.links li.menu-top.langs-links a {
  border: 1px solid #ffffff;
}*/
nav ul.links ul li:not(.link-mask){
  position: relative;
  top: -60px;
}
nav ul li .link-mask {
  height: 70px;
  overflow: hidden;
}
nav ul.links li div:not(.link-mask) {
  transform: translateY(80px);
  opacity: 0;
}
nav ul.links li a {
  font-size: 2em;
  text-decoration: none;
  color: #fff;
  font-weight: 500;
  /*text-shadow: 1px 1px 2px rgba(0, 0, 0, .5);*/
}


nav.open-active {
  transform: translateY(0);
  opacity: 1;
  overflow: auto;
  left: 0;
}
/*nav.open-active ul.links li.menu-top.langs-links {
  right: 60px;
  display: block;
}*/
nav.open-active ul.links li div:not(.link-mask) {
  transform: translateY(0px);
  opacity: 1;
}
nav ul .link-ani-1 div:not(.link-mask) {
  /*transition: all .25s cubic-bezier(.6,0,.8,1.5) .1s;*/
  transition: all .7s ease-in-out .6s;
}
nav ul .link-ani-2 div:not(.link-mask) {
  /*transition: all .25s cubic-bezier(.6,0,.8,1.5) .17s;*/
  transition: all .7s ease-in-out .65s;
}
nav ul .link-ani-3 div:not(.link-mask) {
  /*transition: all .25s cubic-bezier(.6,0,.8,1.5) .24s;*/
  transition: all .7s ease-in-out .7s;
}
nav ul .link-ani-4 div:not(.link-mask) {
  /*transition: all .25s cubic-bezier(.6,0,.8,1.5) .31s;*/
  transition: all .7s ease-in-out .75s;
}
nav ul .link-ani-5 div:not(.link-mask) {
  /*transition: all .25s cubic-bezier(.6,0,.8,1.5) .38s;*/
  transition: all .7s ease-in-out .8s;
}
nav ul .link-ani-6  {
  /*transition: all .25s cubic-bezier(.6,0,.8,1.5) .45s;*/
  transition: all .7s ease-in-out .85s;
}


.btn-wrapper {
  height: 100%;
  width: 30px;
  display: block;
  position: absolute;
  right: 15px;
  z-index: 10;
}
.toggle-btn {
  cursor: pointer;
}
.toggle-btn .bar {
  height: 2px;
  margin: 7px 0;
  background-color: #ffffff;
  transition: all 0.2s ease-in-out;
  /*transition: all 0.3s ease-in-out .2s;*/
}
.toggle-btn .bar:nth-child(1) {
  width: 30px;
}
.toggle-btn .bar:nth-child(2) {
  width: 23px;
}
.toggle-btn .bar:nth-child(3) {
  width: 6px;
}
.toggle-btn .hamburger-menu-word {
  bottom: 3px;
  right: 0px;
  font-size: 7px;
  color: #ffffff;
  transition: all .2s ease-in-out;
}
.scrolled .toggle-btn .bar {
  background-color: #00263d;
}
.scrolled .toggle-btn .hamburger-menu-word {
  color: #00263d;
}
.menu-active .toggle-btn .hamburger-menu-word {
  opacity: 0;
}

label.open-btn-active.toggle-btn .bar {
  background-color: #ffffff;
}
label.open-btn-active.toggle-btn .bar:nth-child(1) {
  transform: translateY(10px) rotate(45deg);
}
label.open-btn-active.toggle-btn .bar:nth-child(2) {
  width: 30px;
  opacity: 0;
}
label.open-btn-active.toggle-btn .bar:nth-child(3) {
  width: 30px;
  transform: translateY(-8px) rotate(-45deg);
}

@media screen and (max-width:991.98px) {
  .btn-wrapper {
    right: 20px;
  }
}
@media screen and (max-width: 767.98px) {
  #nav .nav-address {
    position: static;
    padding-top: 0;
    height: auto;
  }
  #nav .lang-wrapper, .btn-wrapper {
    right: 15px;
  }
  .no-min-h {
    min-height: 0 !important; 
  }
  .menu-content > div {
    min-height: 0 !important;
    margin-top: 150px;
  }
  .menu-content .nav-address.mob {
    margin: 40px 0;
  }
  nav ul li .link-mask {
    height: 55px;
  }
  nav ul.links li a {
    font-size: 28px;
  }
  nav ul.links ul li:not(.link-mask){
    top: 0;
  }
  nav ul.links li div:not(.link-mask) {
    transform: translateY(0px);
    opacity: 1;
  }
  nav ul .link-ani-1 div:not(.link-mask) {
    /*transition: all .25s cubic-bezier(.6,0,.8,1.5) .1s;*/
    transition: all 0s ease 0s;
  }
  nav ul .link-ani-2 div:not(.link-mask) {
    /*transition: all .25s cubic-bezier(.6,0,.8,1.5) .17s;*/
    transition: all 0s ease 0s;
  }
  nav ul .link-ani-3 div:not(.link-mask) {
    /*transition: all .25s cubic-bezier(.6,0,.8,1.5) .24s;*/
    transition: all 0s ease 0s;
  }
  nav ul .link-ani-4 div:not(.link-mask) {
    /*transition: all .25s cubic-bezier(.6,0,.8,1.5) .31s;*/
    transition: all 0s ease 0s;
  }
  nav ul .link-ani-5 div:not(.link-mask) {
    /*transition: all .25s cubic-bezier(.6,0,.8,1.5) .38s;*/
    transition: all 0s ease 0s;
  }
  nav ul .link-ani-6  {
    /*transition: all .25s cubic-bezier(.6,0,.8,1.5) .45s;*/
    transition: all 0s ease 0s;
  }
}
</style>
